import React, {useEffect, useState} from "react";
import {useStripe} from "@stripe/react-stripe-js";
import ResultPaymentPopup from "../ResultPaymentPopup/ResultPaymentPopup";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

interface Check3DSecurePaymentProps {
    paymentIntentId: string;
    fromUrl: string
}

const Check3DSecurePayment: React.FC<Check3DSecurePaymentProps> = ({paymentIntentId, fromUrl}) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const [isPaymentSuccess, setIsPaymentSuccess] = useState<boolean | null>(null);
    const [showResultPaymentPopup, setShowResultPaymentPopup] = useState<boolean>(false);

    useEffect(() => {
        navigate({
            pathname: fromUrl,
            search: ""
        }, {replace: true});
    }, []);

    const stripe = useStripe();

    useEffect(() => {
        if (!stripe) return;
        stripe.retrievePaymentIntent(paymentIntentId).then(res => {
            if (res.paymentIntent) {
                if (res.paymentIntent.status === "succeeded") {
                    setIsPaymentSuccess(true);
                    setShowResultPaymentPopup(true);
                } else {
                    setIsPaymentSuccess(false);
                    setShowResultPaymentPopup(true);
                }

            }
        })

    }, [stripe]);

    return (
        <>
            {isPaymentSuccess !== null && showResultPaymentPopup && (
                <ResultPaymentPopup
                    type={isPaymentSuccess ? "success" : "failed"}
                    title={isPaymentSuccess ? t("PaymentDoneSuccessfully") : t("PaymentFailed")}
                    description={isPaymentSuccess ? t("YourPaymentIsDoneSuccessfullyCheckYourEmailForConfirmation") : t("YourPaymentFailedPleaseTryAgain")}
                    clickOnBack={() => {
                        setShowResultPaymentPopup(false);
                        setIsPaymentSuccess(null);
                    }}
                />
            )}
        </>
    )

}

export default Check3DSecurePayment;